/* ============================================
   Cart 3-tier reward bar
   Fully self-contained: does not modify
   assets/theme.js. Watches the existing
   ".js-cart-total" element (which theme.js
   already updates on every add/remove/qty
   change) with a MutationObserver, and on
   every change re-fetches /cart.js and
   recomputes the tier progress, dot states,
   headline text, the "spend more" hints
   shown inside the upsell rows, the item
   word (ITEM/ITEMS) and the footer subtotal.
   ============================================ */
(function () {
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function fillTemplate(str, map) {
    return str.replace(/\[(\w+)\]/g, function (match, key) {
      return map[key] !== undefined ? map[key] : match;
    });
  }

  function updateTiers(total) {
    var root = document.querySelector('.js-cart-tiers');
    var hints = document.querySelectorAll('.js-milestone-hint');
    if (!root && !hints.length) return;

    var tierEls = root ? root.querySelectorAll('.js-cart-tiers-label') : [];
    var tiers = [1, 2, 3].map(function (n) {
      var value = root ? parseInt(root.getAttribute('data-tier' + n + '-value'), 10) || 0 : 0;
      var label = root ? (root.getAttribute('data-tier' + n + '-label') || '') : '';
      return { value: value, label: label };
    });
    var maxValue = tiers[2].value;

    var nextTier = null;
    for (var i = 0; i < tiers.length; i++) {
      if (total < tiers[i].value) { nextTier = tiers[i]; break; }
    }

    if (root) {
      var beforeText = root.getAttribute('data-before-text') || 'ADD [amount] MORE';
      var unlockText = root.getAttribute('data-unlock-text') || 'UNLOCK [reward]';
      var completeText = root.getAttribute('data-complete-text') || 'You have unlocked [reward]!';
      var headline = root.querySelector('.js-cart-tiers-headline');
      var fill = root.querySelector('.js-cart-tiers-fill');
      var dots = root.querySelectorAll('.js-cart-tiers-dot');

      if (headline) {
        if (nextTier) {
          var remaining = nextTier.value - total;
          var before = fillTemplate(beforeText, { amount: formatMoney(remaining) });
          var unlock = fillTemplate(unlockText, { reward: nextTier.label });
          headline.innerHTML =
            '<span class="cart-tiers__before">' + before + '</span>' +
            '<span class="cart-tiers__arrow"> → </span>' +
            '<span class="cart-tiers__unlock">' + unlock + '</span>';
        } else {
          headline.textContent = fillTemplate(completeText, { reward: tiers[2].label });
        }
      }

      if (fill) {
        var fillPercent = maxValue > 0 ? Math.min(100, (total / maxValue) * 100) : 0;
        fill.style.width = fillPercent + '%';
      }

      Array.prototype.forEach.call(dots, function (dot) {
        var idx = parseInt(dot.getAttribute('data-tier'), 10) - 1;
        var pos = maxValue > 0 ? Math.min(100, (tiers[idx].value / maxValue) * 100) : 0;
        dot.style.left = pos + '%';
        var achieved = total >= tiers[idx].value;
        dot.classList.toggle('is-achieved', achieved);
        dot.classList.toggle('is-current', !achieved && nextTier === tiers[idx]);
      });

      Array.prototype.forEach.call(tierEls, function (label) {
        var idx = parseInt(label.getAttribute('data-tier'), 10) - 1;
        var achieved = total >= tiers[idx].value;
        label.classList.toggle('is-achieved', achieved);
        label.classList.toggle('is-current', !achieved && nextTier === tiers[idx]);
      });
    }

    var hintText = nextTier
      ? 'Spend ' + formatMoney(nextTier.value - total) + ' more → unlock ' + nextTier.label
      : '';
    Array.prototype.forEach.call(hints, function (el) {
      el.textContent = hintText;
      el.hidden = !hintText;
    });
  }

  function updateItemWord(count) {
    var els = document.querySelectorAll('.js-cart-item-word');
    Array.prototype.forEach.call(els, function (el) {
      el.textContent = count === 1 ? 'ITEM' : 'ITEMS';
    });
  }

  function updateSubtotal(cents) {
    var els = document.querySelectorAll('.js-cart-subtotal');
    Array.prototype.forEach.call(els, function (el) {
      el.textContent = formatMoney(cents);
    });
  }

  function refreshFromCart() {
    fetch('/cart.js', { cache: 'no-store', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateTiers(cart.total_price);
        updateItemWord(cart.item_count);
        updateSubtotal(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
      })
      .catch(function () {});
  }

  function init() {
    var totalEl = document.querySelector('.js-cart-total');
    if (totalEl && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () { refreshFromCart(); });
      observer.observe(totalEl, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('.js-grid-cart, .js-upsell-variant-trigger, .js-remove-mini-cart, .js-qty__adjust, .upsell-variant-sheet__add')) {
        setTimeout(refreshFromCart, 350);
        setTimeout(refreshFromCart, 900);
      }
    }, true);
    refreshFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
